import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Route, Routes } from "react-router-dom";
import { useAuthorization } from "../../../common/providers/AuthorizationProvider";
import "./style.css";
import Show from "./Show";
import Edit from "./Edit";
import Create from "./Create";
import useListProjectVariables from "./common/api/useListProjectVariables";

const ProductsV2Mspa = ({
  productType,
}: {
  productType: "products";
}): JSX.Element => {
  const {
    allProjectVariables,
    isLoading: projectVariablesLoading,
    error,
    refetch,
    isFetching,
  } = useListProjectVariables("product");

  return (
    <div className="productsV2">
      <Routes>
        <Route path="/" element={<Show productType={productType} />} />
        <Route
          path="/:id/edit"
          element={<Edit allProjectVariables={allProjectVariables} />}
        />
        <Route
          path="/new"
          element={<Create allProjectVariables={allProjectVariables} />}
        />
      </Routes>
    </div>
  );
};

export default ProductsV2Mspa;
